import { InjectionToken, ValueProvider } from '@angular/core';
import MobileDetect from 'mobile-detect';

const TextbookMobileDetectToken = new InjectionToken<MobileDetect>('TxtbMobileDetectProvider');

const TextbookMobileDetectProvider: ValueProvider = {
  provide: TextbookMobileDetectToken,
  useValue: new MobileDetect(window.navigator.userAgent),
};

export { TextbookMobileDetectToken, TextbookMobileDetectProvider };
